import { fromEvent } from 'rxjs';
import { bufferCount, filter, map } from 'rxjs/operators';
import { DebugGUI } from './gui_debug';
import { Sdk } from './sdk_base';
class SdkDebug extends Sdk {
    constructor() {
        super({
            fps: false,
            trackables: false,
            allowFaceToFaceMode: false,
        });
        // Watch for destroyed events & keep local reference in sync
        DebugGUI.onGUIDestroyed.subscribe(() => (this.gui = undefined));
        // Watch for Konami Code, then create new GUI if not already shown
        this.listenForKonamiCode().subscribe(() => (this.gui ?? (this.gui = new DebugGUI(this))));
        const urlParams = new URLSearchParams(window.location.search);
        const debug = urlParams.get('debug');
        if (!debug)
            return;
        const debugFlags = debug.split(',');
        for (const flag of debugFlags) {
            switch (flag) {
                case 'gui': // Intentional fallthrough
                case 'true':
                    this.gui ?? (this.gui = new DebugGUI(this));
            }
        }
    }
    get allowFaceToFaceMode() {
        return this.flags.allowFaceToFaceMode;
    }
    set allowFaceToFaceMode(value) {
        this.updateFlag('allowFaceToFaceMode', value);
    }
    get fps() {
        return this.flags.fps;
    }
    set fps(value) {
        this.updateFlag('fps', value);
    }
    get trackables() {
        return this.flags.trackables;
    }
    set trackables(value) {
        this.updateFlag('trackables', value);
    }
    listenForKonamiCode() {
        const KONAMI = [
            'ArrowUp',
            'ArrowUp',
            'ArrowDown',
            'ArrowDown',
            'ArrowLeft',
            'ArrowRight',
            'ArrowLeft',
            'ArrowRight',
            'b',
            'a',
        ].join();
        const konamiObservable = fromEvent(document, 'keydown').pipe(map((v) => v.key), bufferCount(10, 1), filter(code => code.join() === KONAMI));
        return konamiObservable;
    }
}
// This is a singleton, default export is valid here.
// eslint-disable-next-line import/no-default-export
export default new SdkDebug();
//# sourceMappingURL=sdk_debug.js.map